/**
 * O prazo de atendimento escrito para gente: "8 h de expediente", "1 dia útil", "3 dias úteis".
 *
 * A1 (06/10/2026): a tabela do catálogo mostrava só o número, e "8" de horas e "1" de dia útil apareciam
 * na mesma coluna sem dizer a unidade. Função pura em módulo próprio (régua da casa: ajudante puro não mora
 * em arquivo de componente).
 */
export function textoDoPrazo(numero: number | null | undefined, unidade: string | null | undefined): string {
  if (numero === null || numero === undefined || numero <= 0) return '—';
  if (unidade === 'dias_uteis') return `${numero} ${numero === 1 ? 'dia útil' : 'dias úteis'}`;
  return `${numero} h de expediente`;
}
